<template>
  <div class="home">
    <div class="section-headline">
      <div class="section-image"></div>
      <div class="section-type">
        <vue-typed-js :strings="[
          'Create free events',
          'Explore sponsorship proposals',
          'Scale your event outreach',
          ]" :loop="true" :backDelay="2000" :backSpeed="10">
          <h1 class="header-type-script">
            <span class="typing"></span>
          </h1>
        </vue-typed-js>
        <h2 class="hero-header-text">
          Get the ideal sponsorship package tailored for your event
        </h2>
        <router-link class="cta-button" to="/event/new/edit" @click.native="ctaClick">
          <h3 class="event-cta-button" v-if="authenticated">Create Event</h3>
          <h3 class="event-cta-button" v-else>Join The Community</h3>
        </router-link>
      </div>
    </div>
    <div>
      <div class="event-page-steps-wrapper" v-if="!authenticated">
        <div class="event-page-steps-title">
          <h2>How do I get sponsored?</h2>
          <p>Empower Sponsors and Events with an easy-to-use tool.</p>
        </div>
        <section class="event-steps-columns">
          <div class="event-steps-column">
            <div class="number">1</div>
            <h3>Create Event</h3>
            <p>Firstly sign up and create a profile. Craft the sponsorship pitch for
              your event so that sponsors understand what you can offer them.</p>
          </div>
          <div class="event-steps-column">
            <div class="number">2</div>
            <h3>List Sponsorship Packages</h3>
            <p>Structure your sponsorship packages with key event metrics that will lead to
              business outcomes for brand partners.</p>
          </div>
          <div class="event-steps-column">
            <div class="number">3</div>
            <h3>Connect With Brands</h3>
            <p>Once your event is live, start passively receiving applications
              from brands that are interested in your sponsorship packages.</p>
          <div class="learn-more">
            <a :href="blogUrl" target="_blank" rel="noopener">Learn about Event Sponsorship</a>
          </div>
          </div>
        </section>
      </div>
      <div class="flexible-features" v-if="!authenticated">
        <div class="feature-text">
          <h2>What We Offer</h2>
          <p>By offering sponsorship package deals to brands,
            you unlock more money to spend on your event.</p>
        </div>
        <div class="box-feature">
          <div class="box-feature-item" v-for="(boxFeatureItem, i) in boxFeatureItems" :key="i">
            <img :src="getResolvedPathForBoxFeatureItemImage(boxFeatureItem.img)"
              :alt="boxFeatureItem.text">
            <span>{{boxFeatureItem.text}}</span>
          </div>
        </div>
      </div>
      <div class="home-event-cards-container">
        <event-cards :events="events" activeEventsTitle="Featured Events"
          class="home-event-cards" />
      </div>
      <div v-if="!authenticated">
        <div class="get-sponsored-container">
          <h2>Ready to get started?</h2>
          <div>
          <router-link class="get-started-button" to="/event/new/edit">
            <div>Create Free Account</div>
          </router-link>
            <a class="event-organizers-handbook"
            :href="`${blogUrl}/youpaireds-event-sponsorship-handbook/`"
            target="_blank" rel="noopener">Organizers Handbook</a>
          </div>
        </div>
        <div class="event-page-solution-wrapper">
          <div class="event-page-steps-title">
          <h2>YouPaired is here for you</h2>
          <!--Organizing a event, conference or trade show can be a daunting challenge for
            Event Organizersand Business owners. -->
          <p>Increase the number of impressions
            on the listing of your event and increase its visibility.</p>
          </div>
          <section class="event-steps-columns">
            <div class="event-steps-column">
              <h3>Why create events on YouPaired?</h3>
              <p>YouPaired allows events to be discovered by a large number of brands
                and streamlines your outreach process to save event organizers time
                when seeking sponsorship.</p>
              <!--p>On the flip side, YouPaired simplifies the event discovery workflow
                for event markets by allowing them to search, and evaluate sponsorship
                packages all in one place./p-->
            </div>
            <div class="event-steps-column">
              <h3>Who should use YouPaired?</h3>
              <p>YouPaired is a free event sponsorship marketplace for event organizers,
                startups or businesses who love to host events. Get sponsored for festivals,
                conferences, trade shows, global seminars, networking meets workshops,
                and many more!</p>
               <div class="learn-more">
               <a :href="helpUrl" target="_blank" rel="noopener">Learn more about YouPaired</a>
               </div>
            </div>
          </section>
        </div>
        <div class="partner-profile">
          <div class="powered-by">
            <h2>Powered by</h2>
          </div>
          <div class="partner-logos">
            <img src="https://d3imvbcc5ff32n.cloudfront.net/partners/MongoDb-accelarator.png"
            alt="MongoDB Startup Accelerator">
            <img src="https://d3imvbcc5ff32n.cloudfront.net/partners/gan-logos.png"
            alt="GAN startup">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventCards from '@/components/event/view/EventCards.vue';

export default {
  name: 'home',
  components: {
    EventCards,
  },
  computed: {
    ...mapState('auth', ['backendAxios', 'authenticated']),
    blogUrl: () => process.env.VUE_APP_BLOG_URL,
    helpUrl: () => process.env.VUE_APP_HELP_URL,
  },
  async mounted() {
    try {
      const response = await this.backendAxios
        .post('/sponsorship-event/filter');
      this.events = response.data.events;
    } catch (err) {
      this.$toasted.show(err.response.data, {
        type: 'info',
      });
    }
  },
  metaInfo() {
    const title = 'Free Event Sponsorship Marketplace| Get Sponsored Here';
    const description = 'Discover the free event sponsorship marketplace. YouPaired helps marketers discover, evaluate, manage, and report effective sponsorship deals.';
    const metaTagLogo = 'https://images.youpaired.com/youPaired-logo-metatag.jpg';
    const keywords = ['youpaired', 'sponsor my event', 'how to get sponsored', 'sponsorship pitch template',
      'events looking for sponsors', 'sponsorship website', 'event sponsorship proposals', 'corporate sponsorship',
      'event sponsorship platform', 'get a sponsor for an event'];
    return {
      title,
      link: [{
        rel: 'canonical', href: this.$route.path,
      }],
      meta: [{
        'http-equiv': 'Content-Type',
        content: 'text/html; charset=utf-8',
      }, {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      }, {
        name: 'description',
        content: description,
      }, {
        name: 'image',
        content: metaTagLogo,
      }, {
        itemprop: 'name',
        content: title,
      }, {
        itemprop: 'description',
        content: description,
      }, {
        itemprop: 'keywords',
        content: keywords.join(','),
      }, {
        itemprop: 'image',
        content: metaTagLogo,
      }, {
        name: 'twitter:card',
        content: 'summary',
      }, {
        name: 'twitter:title',
        content: title,
      }, {
        name: 'twitter:description',
        content: description,
      }, {
        name: 'twitter:site',
        content: '@youpaired',
      }, {
        name: 'twitter:creator',
        content: '@youpaired',
      }, {
        name: 'twitter:image:src',
        content: metaTagLogo,
      }, {
        name: 'og:title',
        content: title,
      }, {
        name: 'og:description',
        content: description,
      }, {
        name: 'og:image:secure_url',
        content: metaTagLogo,
      }, {
        name: 'og:url',
        content: this.$route.path,
      }, {
        name: 'og:site_name',
        content: 'YouPaired',
      }, {
        name: 'fb:app_id',
        content: process.env.VUE_APP_FB_APP_ID,
      }, {
        name: 'og:type',
        content: 'website',
      }],
    };
  },
  data() {
    return {
      events: [],
      boxFeatureItems: [{
        img: 'free-to-use',
        text: 'NO HIDDEN FEES',
      }, {
        img: 'easy-to-use',
        text: 'EASY TO USE',
      }, {
        img: 'collaborate-team',
        text: 'TEAM COLLABORATION',
      }, {
        img: 'unlimited-sponsorship',
        text: 'CUSTOMIZABLE OFFERS',
      }],
    };
  },
  methods: {
    getResolvedPathForBoxFeatureItemImage(boxFeatureItemImage) {
      // eslint-disable-next-line
      return require(`../assets/home-page/box-features/${boxFeatureItemImage}.svg`);
    },
    ctaClick() {
      this.$ga.event('home', 'cta', this.authenticated ? 'auth' : 'notAuth', 1);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.home {
  position: relative;
}

.home-event-cards-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.home-event-cards {
  position: relative;
}

.section-headline {
  position: relative;
}

.section-image {
  min-height: 100%;
  height: 100%;
  min-width: 100%;
  background-repeat:no-repeat;
  background-size:contain;
  background-position:center;
  position: absolute;
  background-color: #000000;
  background-image: linear-gradient( rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.6) ),
    url(../assets/home-page/main-banner.jpg);
  background-size: cover;
  border-bottom: 1px solid #2e2e2e;
}

.section-type {
  position: relative;
  height: 80vh;
  font-weight: 700;
  color: white;
  text-shadow: 0 3px 5px rgb(0, 0, 0);
}

.header-type-script {
  font-size: 3.5rem;
  position: absolute;
  top: 10%;
  width: 100%;
  text-align: center;
  margin: 0;
}

.hero-header-text {
  font-size: 2rem;
  top: 35%;
  text-align: center;
  padding: 0 1em;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.cta-button {
  cursor: pointer;
  border-radius: 0.25rem;
  color: #444444;
  background-color: $event-cta-button;
  font-size: 1.25rem;
  border: 1px solid $event-cta-button;
  font-weight: bold;
  white-space: nowrap;
  letter-spacing: .10em;
  text-decoration: none;
  box-shadow: 0 10px 20px 3px rgba(82, 104, 206, 0.15);
  position: absolute;
  top: 55%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  justify-content: center;
  height: auto;
  max-width: 18rem;
  z-index: 25;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:  1rem 0.5rem;
  text-shadow: none;
  &:hover {
    transform: scale(1.05);
    border:none;
}
}
.partner-profile {
  padding: 1rem 0;
  margin: 3rem 0 0 0;
  background: #f8f9ff;
}

.flexible-features {
  padding: 1rem 0;
}

.feature-text {
  max-width: 100%;
  text-align: center;
  color: black;
  margin: auto;
  padding: 0 10px;
  animation: fade-in;
  animation-duration: 8s;
}

.feature-text h2 {
  text-align: center;
  font-size: 2rem;
}

.feature-text p {
  font-size: 1.25rem;
}

.box-feature {
  display: flex;
  flex-wrap: wrap;
  max-width: 750px;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  max-height: auto;
}

.box-feature-item {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  margin-bottom: 1rem;
}

.box-feature-item > img {
  width: 50%;
  box-shadow: 1px 1px 2px #e6e6e6, 0 0 5px #e6e6e6, 0 0 5px #e6e6e6;
  margin: 1rem 0;
  border-radius: 10%;
  &:hover {
    box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
}
}

.box-feature-item > span {
  font-size: 1.15rem;
  font-weight: 600;
}

.get-started-button, .event-organizers-handbook {
  display: inline-block;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
  width: auto;
  cursor: pointer;
  border-radius: 4px;
  font-size: 1.25rem;
  line-height: 1.5rem;
  letter-spacing: normal;
  font-weight: 800;
  border-width: 2px;
  border-style: solid;
  padding: 1rem 1.5rem;
  box-shadow: none;
  background: transparent;
  border-color: #444444;
  color: #444444;
  margin: 0.5rem;
  &:hover {
    background-color: $login-hover;
    color:#fff;
    border-color: $login-hover;
  }
}

.event-cta-button {
  margin: 0 auto;
}

.powered-by {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  font-size: 1.5rem;
}

.powered-by h1 {
  margin: 0;
}

.event-page-steps-wrapper h2 {
  text-align: center;
  font-size: 2rem;
}

.event-page-steps-wrapper p {
  margin: 0 auto;
  font-size: 1.25rem;
}

.event-page-solution-wrapper h2 {
  text-align: center;
  font-size: 2rem;
}

.event-page-solution-wrapper p {
  margin: 0.25rem auto;
  font-size: 1.15rem;
  letter-spacing: 1px;
}

.event-steps-column h3 {
  text-align: left;
  font-size: 1.5rem;
}


.partner-logos {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1rem 0;
  margin-bottom: 1rem;
}

.partner-logos > img {
  margin-right: 1rem;
  width: 10rem;
}

.get-sponsored-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  padding: 3rem;
  background: #f8f9ff;
}

.get-sponsored-container h2, .powered-by h2 {
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
}

.event-page-steps-wrapper {
  padding: 5px;
  max-width: 1200px;
  margin: 20px auto;
}

.event-page-solution-wrapper {
  padding: 5px;
  max-width: 900px;
  margin: 20px auto;
}

.event-steps-columns {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin: 5px 0;
  justify-content: space-between;
}

.event-steps-column {
  flex: 1;
  max-width: 350px;
  font-size: 1rem;
  // margin: 0.5rem;
  margin: 0.5rem 0;
}

.event-steps-column .number {
  font-size: 1.5rem;
  border: 2px solid black;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin: 1rem 0 0 0;
}

.event-steps-column h2 {
  margin-top: 0.5rem;
}

.learn-more {
  margin-top: 1.5rem;
}

.learn-more a{
  color: $login-background;
  font-size: 1.25rem;
  text-align: center;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.event-page-steps-title > p {
  text-align: center;
}

@media screen and (max-width: 1200px) {
  .event-page-steps-wrapper {
    max-width: 600px;
    margin: 0 auto;
    width: 95%;
  }

  .event-page-solution-wrapper {
    max-width: 600px;
    margin: 0 auto;
    width: 95%;
  }

  .event-page-solution-wrapper h2 {
    text-align: left;
  }

  .event-page-steps-title {
    max-width: 100%;
  }

  .event-page-steps-title > h2 {
    font-size: 2rem;
    text-align: left;
  }

  .event-page-steps-title > p {
    text-align: left;
  }

  .event-steps-columns {
    flex-direction: column;
  }

  .event-steps-column {
    max-width: 100%;
  }
}

@media screen and (max-width: 823px) {
  .header-type-script {
    font-size: 2.5rem;
    top: 5%;
  }

  .hero-header-text {
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .cta-button {
    margin-top: 3.5rem;
    padding: 0.25rem;
  }
  .event-organizers-handbook, .get-started-button {
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    padding: 0.75rem;
    width: 10rem;
  }
  .box-feature {
    width: 100%;
  }

  .box-feature-item {
    width: 100%;
  }

  .box-feature-item > img {
    width: 30%;
  }

  .event-cta-button {
    padding: 0.5rem 1rem;
  }

  .feature-text p {
    text-align: left;
  }

}

@media only screen and (min-device-width: 768px) and
  (max-device-width: 1024px) and (orientation:portrait) {
      /* For portrait layouts only iPad */
  .header-type-script {
    font-size: 3.5rem;
    top: 15%;
  }

  .hero-header-text {
    font-size: 2rem;
    margin-top: 1rem;
  }

  .cta-button {
    margin-top: 3rem;
    padding: 0.5rem;
    max-width: 30rem;
  }

  .box-feature-item > img {
      width: 50%;
    }
}

@media only screen and (min-device-width: 1024px) and
  (max-device-width: 1366px) and (orientation:portrait) {
  /* For portrait layouts only iPad Pro */
  .header-type-script {
    font-size: 4rem;
    top: 15%;
  }

  .hero-header-text {
    font-size: 3rem;
    margin-top: 1rem;
  }

  .cta-button {
    margin-top: 3.5rem;
    padding:0.5rem;
    max-width:30rem;
  }
}

@media only screen and (min-device-width: 1024px) and
  (max-device-width: 1366px) and (orientation:landscape) {
      /* For landscape layouts only iPad Pro */
  .header-type-script {
    font-size: 4rem;
      top: 15%;
  }

  .header-bottom-small {
    font-size: 3rem;
    margin-top: 1rem;
  }

  .cta-button {
    margin-top: 3.5rem;
    padding:1rem;
    max-width:30rem;
  }
}

</style>
